import { Injectable } from "@angular/core";

import { MountingStrategy } from "./mounting.strategy";

@Injectable({
	providedIn: "root",
})
export class StencilModuleMountingStrategy implements MountingStrategy {
	async mount(module: { defineCustomElements: () => void }) {
		await module.defineCustomElements();
	}
}
